import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import PrivateRoute from './privateroute';
import useAuth from './utils/firebase';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

import Home from './pages/home';
import Login from './pages/login';
import PrivacyPolicy from './pages/privacy-policy';
import Root from './pages/root';
import Support from './pages/support';

export default function App() {

  const { isLoading, user } = useAuth()

  if (isLoading) {
    return (
      <p>Trying to log in</p>
    )
  }

  return (
    <Router>
      <Route exact path="/" component={Root} />
      <Route exact path="/support" component={Support} />
      <Route exact path="/privacy-policy" component={PrivacyPolicy} />
      <PrivateRoute path="/home" component={Home} />
      <Route exact path="/login" component={Login} />
    </Router>
  )
}
